import React from "react";
import PT from "prop-types";
import Popover from "_c/Popover";

const Rest = (props) => {
  const Button = props.restButtonRenderer;
  const Renderer = props.itemRenderer;
  const RestContainer = props.restContainerRenderer;

  if (props.items.length <= props.limit) {
    return props.items.map((item, idx) => (
      <Renderer key={idx} {...item} {...props.itemProps} />
    ));
  }
  const head = props.items.slice(0, props.limit);
  const tail = props.items.slice(props.limit);
  return (
    <>
      {head.map((item, idx) => (
        <Renderer {...item} {...props.itemProps} key={idx} />
      ))}
      <Popover
        content={
          <RestContainer>
            {tail.map((item, idx) => (
              <Renderer {...item} {...props.itemProps} key={idx} />
            ))}
          </RestContainer>
        }
      >
        <Button />
      </Popover>
    </>
  );
};
Rest.propTypes = {
  limit: PT.number.isRequired,
  items: PT.array,
  itemRenderer: PT.func.isRequired,
  itemProps: PT.object,
  restItemRenderer: PT.func,
  restButtonRenderer: PT.any,
  restContainerRenderer: PT.any,
};
export default Rest;
